import { render, staticRenderFns } from "./DocStart.vue?vue&type=template&id=4c83d4ba&scoped=true&"
import script from "./DocStart.vue?vue&type=script&lang=js&"
export * from "./DocStart.vue?vue&type=script&lang=js&"
import style0 from "./DocStart.vue?vue&type=style&index=0&id=4c83d4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83d4ba",
  null
  
)

export default component.exports